module.exports = __webpack_public_path__ + "img/weatherpedia-pwa5.c5dd9f51.jpeg";